export const bookThemes = {
  en: {
    // UI Elements
    old_testament_display: 'OLD TESTAMENT',
    new_testament_display: 'NEW TESTAMENT', 
    popular: 'Popular',
    chapters: 'chapters',
    scripture_study: 'Scripture Study',
    
    // Bible Book Themes
    creation_origins: 'Creation & Origins',
    freedom_law: 'Freedom & Law',
    holiness_worship: 'Holiness & Worship',
    journey_faith: 'Journey & Faith',
    covenant_law: 'Covenant & Law',
    conquest_victory: 'Conquest & Victory',
    leadership_cycles: 'Leadership & Cycles',
    love_loyalty: 'Love & Loyalty',
    worship_prayer: 'Worship & Prayer',
    wisdom_life: 'Wisdom & Life',
    king_kingdom: 'King & Kingdom',
    servant_action: 'Servant & Action',
    savior_compassion: 'Savior & Compassion',
    son_god_love: 'Son of God & Love',
    church_mission: 'Church & Mission',
    gospel_grace: 'Gospel & Grace',
    victory_glory: 'Victory & Glory'
  },
  
  fr: {
    // UI Elements
    old_testament_display: 'ANCIEN TESTAMENT',
    new_testament_display: 'NOUVEAU TESTAMENT', 
    popular: 'Populaire',
    chapters: 'chapitres',
    scripture_study: 'Étude des Écritures',
    
    // Bible Book Themes
    creation_origins: 'Création & Origines',
    freedom_law: 'Liberté & Loi',
    holiness_worship: 'Sainteté & Adoration',
    journey_faith: 'Voyage & Foi',
    covenant_law: 'Alliance & Loi',
    conquest_victory: 'Conquête & Victoire',
    leadership_cycles: 'Leadership & Cycles',
    love_loyalty: 'Amour & Loyauté',
    worship_prayer: 'Adoration & Prière',
    wisdom_life: 'Sagesse & Vie',
    king_kingdom: 'Roi & Royaume',
    servant_action: 'Serviteur & Action',
    savior_compassion: 'Sauveur & Compassion',
    son_god_love: 'Fils de Dieu & Amour',
    church_mission: 'Église & Mission',
    gospel_grace: 'Évangile & Grâce',
    victory_glory: 'Victoire & Gloire'
  },
  
  es: {
    // UI Elements
    old_testament_display: 'ANTIGUO TESTAMENTO',
    new_testament_display: 'NUEVO TESTAMENTO', 
    popular: 'Popular',
    chapters: 'capítulos',
    scripture_study: 'Estudio de las Escrituras',
    
    // Bible Book Themes
    creation_origins: 'Creación & Orígenes',
    freedom_law: 'Libertad & Ley',
    holiness_worship: 'Santidad & Adoración',
    journey_faith: 'Viaje & Fe',
    covenant_law: 'Pacto & Ley',
    conquest_victory: 'Conquista & Victoria',
    leadership_cycles: 'Liderazgo & Ciclos',
    love_loyalty: 'Amor & Lealtad',
    worship_prayer: 'Adoración & Oración',
    wisdom_life: 'Sabiduría & Vida',
    king_kingdom: 'Rey & Reino',
    servant_action: 'Siervo & Acción',
    savior_compassion: 'Salvador & Compasión',
    son_god_love: 'Hijo de Dios & Amor',
    church_mission: 'Iglesia & Misión',
    gospel_grace: 'Evangelio & Gracia',
    victory_glory: 'Victoria & Gloria'
  },
  
  de: {
    // UI Elements
    old_testament_display: 'ALTES TESTAMENT',
    new_testament_display: 'NEUES TESTAMENT', 
    popular: 'Beliebt',
    chapters: 'Kapitel',
    scripture_study: 'Schriftstudium',
    
    // Bible Book Themes
    creation_origins: 'Schöpfung & Ursprünge',
    freedom_law: 'Freiheit & Gesetz',
    holiness_worship: 'Heiligkeit & Anbetung',
    journey_faith: 'Reise & Glaube',
    covenant_law: 'Bund & Gesetz',
    conquest_victory: 'Eroberung & Sieg',
    leadership_cycles: 'Führung & Zyklen',
    love_loyalty: 'Liebe & Treue',
    worship_prayer: 'Anbetung & Gebet',
    wisdom_life: 'Weisheit & Leben',
    king_kingdom: 'König & Königreich',
    servant_action: 'Diener & Handlung',
    savior_compassion: 'Retter & Mitgefühl',
    son_god_love: 'Sohn Gottes & Liebe',
    church_mission: 'Kirche & Mission',
    gospel_grace: 'Evangelium & Gnade',
    victory_glory: 'Sieg & Herrlichkeit'
  },
  
  pt: {
    // UI Elements
    old_testament_display: 'ANTIGO TESTAMENTO',
    new_testament_display: 'NOVO TESTAMENTO', 
    popular: 'Popular',
    chapters: 'capítulos',
    scripture_study: 'Estudo das Escrituras',
    
    // Bible Book Themes
    creation_origins: 'Criação & Origens',
    freedom_law: 'Liberdade & Lei',
    holiness_worship: 'Santidade & Adoração',
    journey_faith: 'Jornada & Fé',
    covenant_law: 'Aliança & Lei',
    conquest_victory: 'Conquista & Vitória',
    leadership_cycles: 'Liderança & Ciclos',
    love_loyalty: 'Amor & Lealdade',
    worship_prayer: 'Adoração & Oração',
    wisdom_life: 'Sabedoria & Vida',
    king_kingdom: 'Rei & Reino',
    servant_action: 'Servo & Ação',
    savior_compassion: 'Salvador & Compaixão',
    son_god_love: 'Filho de Deus & Amor',
    church_mission: 'Igreja & Missão',
    gospel_grace: 'Evangelho & Graça',
    victory_glory: 'Vitória & Glória'
  },
  
  ru: {
    // UI Elements
    old_testament_display: 'ВЕТХИЙ ЗАВЕТ',
    new_testament_display: 'НОВЫЙ ЗАВЕТ', 
    popular: 'Популярное',
    chapters: 'глав',
    scripture_study: 'Изучение Писания',
    
    // Bible Book Themes
    creation_origins: 'Творение & Истоки',
    freedom_law: 'Свобода & Закон',
    holiness_worship: 'Святость & Поклонение',
    journey_faith: 'Путешествие & Вера',
    covenant_law: 'Завет & Закон',
    conquest_victory: 'Завоевание & Победа',
    leadership_cycles: 'Лидерство & Циклы',
    love_loyalty: 'Любовь & Верность',
    worship_prayer: 'Поклонение & Молитва',
    wisdom_life: 'Мудрость & Жизнь',
    king_kingdom: 'Царь & Царство',
    servant_action: 'Слуга & Действие',
    savior_compassion: 'Спаситель & Сострадание',
    son_god_love: 'Сын Божий & Любовь',
    church_mission: 'Церковь & Миссия',
    gospel_grace: 'Евангелие & Благодать',
    victory_glory: 'Победа & Слава'
  },
  
  tl: {
    // UI Elements
    old_testament_display: 'LUMANG TIPAN',
    new_testament_display: 'BAGONG TIPAN', 
    popular: 'Sikat',
    chapters: 'kabanata',
    scripture_study: 'Pag-aaral ng Kasulatan',
    
    // Bible Book Themes
    creation_origins: 'Paglikha & Pinagmulan',
    freedom_law: 'Kalayaan & Batas',
    holiness_worship: 'Kabanalan & Pagsamba',
    journey_faith: 'Paglalakbay & Pananampalataya',
    covenant_law: 'Tipan & Batas',
    conquest_victory: 'Pagsakop & Tagumpay',
    leadership_cycles: 'Pamumuno & Siklo',
    love_loyalty: 'Pag-ibig & Katapatan',
    worship_prayer: 'Pagsamba & Panalangin',
    wisdom_life: 'Karunungan & Buhay',
    king_kingdom: 'Hari & Kaharian',
    servant_action: 'Alipin & Gawa',
    savior_compassion: 'Tagapagligtas & Habag',
    son_god_love: 'Anak ng Diyos & Pag-ibig',
    church_mission: 'Simbahan & Misyon',
    gospel_grace: 'Ebanghelyo & Biyaya',
    victory_glory: 'Tagumpay & Kaluwalhatian'
  },
  
  it: {
    // UI Elements
    old_testament_display: 'ANTICO TESTAMENTO',
    new_testament_display: 'NUOVO TESTAMENTO', 
    popular: 'Popolare',
    chapters: 'capitoli',
    scripture_study: 'Studio delle Scritture',
    
    // Bible Book Themes
    creation_origins: 'Creazione & Origini',
    freedom_law: 'Libertà & Legge',
    holiness_worship: 'Santità & Adorazione',
    journey_faith: 'Viaggio & Fede',
    covenant_law: 'Alleanza & Legge',
    conquest_victory: 'Conquista & Vittoria',
    leadership_cycles: 'Leadership & Cicli',
    love_loyalty: 'Amore & Lealtà',
    worship_prayer: 'Adorazione & Preghiera',
    wisdom_life: 'Saggezza & Vita',
    king_kingdom: 'Re & Regno',
    servant_action: 'Servo & Azione',
    savior_compassion: 'Salvatore & Compassione',
    son_god_love: 'Figlio di Dio & Amore',
    church_mission: 'Chiesa & Missione',
    gospel_grace: 'Vangelo & Grazia',
    victory_glory: 'Vittoria & Gloria'
  },
  
  am: {
    // UI Elements
    old_testament_display: 'ብሉይ ኪዳን',
    new_testament_display: 'አዲስ ኪዳን', 
    popular: 'ተወዳጅ',
    chapters: 'ምዕራፍ',
    scripture_study: 'የመጽሐፍ ቅዱስ ጥናት',
    
    // Bible Book Themes
    creation_origins: 'ፍጥረት & መነሻዎች',
    freedom_law: 'ነፃነት & ሕግ',
    holiness_worship: 'ቅድስና & አምልኮ',
    journey_faith: 'ጉዞ & እምነት',
    covenant_law: 'ኪዳን & ሕግ',
    conquest_victory: 'ድል & ድል',
    leadership_cycles: 'አመራር & ዑደቶች',
    love_loyalty: 'ፍቅር & ታማኝነት',
    worship_prayer: 'አምልኮ & ጸሎት',
    wisdom_life: 'ጥበብ & ሕይወት',
    king_kingdom: 'ንጉስ & መንግሥት',
    servant_action: 'አገልጋይ & ተግባር',
    savior_compassion: 'መድኃኒት & ርሕራሔ',
    son_god_love: 'የእግዚአብሔር ልጅ & ፍቅር',
    church_mission: 'ቤተ ክርስቲያን & ተልእኮ',
    gospel_grace: 'ወንጌል & ጸጋ',
    victory_glory: 'ድል & ክብር'
  },
  
  ko: {
    // UI Elements
    old_testament_display: '구약성경',
    new_testament_display: '신약성경', 
    popular: '인기',
    chapters: '장',
    scripture_study: '성경 연구',
    
    // Bible Book Themes
    creation_origins: '창조 & 기원',
    freedom_law: '자유 & 율법',
    holiness_worship: '거룩함 & 예배',
    journey_faith: '여행 & 믿음',
    covenant_law: '언약 & 율법',
    conquest_victory: '정복 & 승리',
    leadership_cycles: '리더십 & 순환',
    love_loyalty: '사랑 & 충성',
    worship_prayer: '예배 & 기도',
    wisdom_life: '지혜 & 삶',
    king_kingdom: '왕 & 왕국',
    servant_action: '종 & 행동',
    savior_compassion: '구원자 & 연민',
    son_god_love: '하나님의 아들 & 사랑',
    church_mission: '교회 & 선교',
    gospel_grace: '복음 & 은혜',
    victory_glory: '승리 & 영광'
  }
};